export class ELEMENTSTYPESIDS {
    public static PLATE = '51b97c79cf164388b36bf8edc326887c'
    public static STIFFENER = '8a124b71ba374e08aaded3e7073c8bf0'
    public static FACEPLATE = '573ef4493c3145128bb99d5daa131795'
    public static BRACKET = 'a6ecb8f533f64e7aacb10122adef0d9b'
    public static BEAM = '055fc5dc1d134c57917073c2842a4f24'
    public static BEAMPART = 'c5fbdc28bf80476fa4fe36ff6db71a0a'
    public static CABLE = '4c72bd54f9f549d3ae86ce95ad477f88'
    public static PIPE = 'b6d99dc151c345a3ba3ed2d1745e7449'
    public static CRITICALAREA = '492b52c039a246e2a4806a949f26a0b9'
    public static INSPECTION = '27bc58e55d9f4326846796cfce711039'
    public static ANODE = '586ef87ca4d245e49e05202ff9041151'
    public static PROTECTION = '4e5f78cd5e5f40b4a4b56e2e76f8a0b6'
    public static CONCRETE = 'd1537f8388504c40be9be1c9b322963f'
    public static PAINTING = '5b7494b9-5b47-4de4-9558-70cf8cdaddbd'
    public static WEIGHTAREAELEMENT = '0c588b60-a3e2-4c25-8d7d-7e84fb76a8d0'
    public static REPAIR = '898c1836-a638-465b-b2fc-89c55d1925dd'
    public static REPAIRDOUBLER = '334d684c-048d-47fd-a3b4-fa650e331908'
    public static UNDEFINED = 'f5a289cd3b724434927cb90f2e0b23b6'
    public static REFERENCELINE = '35d4384eae2e482abf11b5b81880cd5e'

    public static getElementTypeName(typeId: string): string {
        switch (typeId) {
            case ELEMENTSTYPESIDS.PLATE:
                return 'Plate';
            case ELEMENTSTYPESIDS.STIFFENER:
                return 'Stiffener';
            case ELEMENTSTYPESIDS.FACEPLATE:
                return 'FacePlate';
            case ELEMENTSTYPESIDS.BRACKET:
                return 'Bracket';
            case ELEMENTSTYPESIDS.BEAM:
                return 'Beam';
            case ELEMENTSTYPESIDS.BEAMPART:
                return 'BeamPart';
            case ELEMENTSTYPESIDS.CABLE:
                return 'Cable';
            case ELEMENTSTYPESIDS.PIPE:
                return 'Pipe';
            case ELEMENTSTYPESIDS.CRITICALAREA:
                return 'Critical Area';
            case ELEMENTSTYPESIDS.INSPECTION:
                return 'Inspection';
            case ELEMENTSTYPESIDS.ANODE:
                return 'Anode';
            case ELEMENTSTYPESIDS.PROTECTION:
                return 'Protection';
            case ELEMENTSTYPESIDS.CONCRETE:
                return 'Concrete';
            case ELEMENTSTYPESIDS.PAINTING:
                return 'Painting';
            case ELEMENTSTYPESIDS.WEIGHTAREAELEMENT:
                return 'Weight Area Element';
            case ELEMENTSTYPESIDS.REPAIR:
                return 'Repair';
            case ELEMENTSTYPESIDS.REPAIRDOUBLER:
                return 'Repair Doubler';
            case ELEMENTSTYPESIDS.REFERENCELINE:
                return 'Reference Line';
            case ELEMENTSTYPESIDS.UNDEFINED:
                return 'Undefined';
            default:
                return 'Unknown';
        }
    }
}
